import type { Configuration } from "@azure/msal-browser";

const CLIENT_ID = import.meta.env.VITE_ENTRA_APP_ID ?? "634c2a2c-f551-4099-b7fa-f0ec40317f71";
const TENANT_ID = import.meta.env.VITE_ENTRA_TENANT_ID ?? "706039ee-ad2b-4749-abde-57d51320088f";

export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT_ID}`,
    redirectUri: `${window.location.origin}/`,
    postLogoutRedirectUri: `${window.location.origin}/`,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: [`api://${CLIENT_ID}/access_as_user`],
};
